import {Dispatch, SetStateAction, useEffect, useState} from 'react';

export function useInitialLoad<T>(fetcher: () => Promise<T>): T | null {
    const [state, setState] = useState<T | null>(null);
    useAsyncEffect(async () => setState(await fetcher()), [])
    return state;
}

export function useAsyncState<T>(fetcher: () => Promise<T>): [T | null, Dispatch<SetStateAction<T | null>>] {
    const [state, setState] = useState<T | null>(null)
    useAsyncEffect(async () => setState(await fetcher()), [])
    return [state, setState];
}

export function useAsyncEffect(effect: () => Promise<void>, deps: any[]) {
    useEffect(() => {
        let isActive = true;
        const runEffect = async () => {
            await effect();
            isActive = false;
        };
        const cleanup = () => { isActive = false; }
        // noinspection JSIgnoredPromiseFromCall
        runEffect();
        return cleanup;
    }, deps);
}
